import FormsBaseMixin from './forms-base-mixin'

export default FormsBaseMixin